import jquery from "./jquery-3.2.1.slim.min";

export default window.$ = window.jQuery = jquery;
